import { z } from 'zod';
import { BannerRedirectType, REDIRECT_TYPES_REQUIRING_COLLECTION } from '../types';

export const bannerFormSchema = z
  .object({
    description: z.string().min(1, 'Descrição é obrigatória').max(255),
    redirectType: z.nativeEnum(BannerRedirectType),
    redirectId: z.string().optional(),
    displayOrder: z.coerce.number().int().min(0).default(0),
    isActive: z.boolean().default(false),
    published: z.boolean().default(false),
    startDate: z.date().optional(),
    endDate: z.date().optional(),
    minBuildAndroid: z.coerce.number().int().min(1).optional().nullable(),
    minBuildIos: z.coerce.number().int().min(1).optional().nullable(),
  })
  .refine(
    (data) =>
      !REDIRECT_TYPES_REQUIRING_COLLECTION.includes(data.redirectType) ||
      Boolean(data.redirectId && data.redirectId.trim().length > 0),
    {
      message: 'redirectId (UUID da collection) é obrigatório para este tipo',
      path: ['redirectId'],
    }
  );

export type BannerFormValues = z.infer<typeof bannerFormSchema>;
